import { MoreOutlined } from '@ant-design/icons';
import { Dropdown } from 'antd';
import React, { useState } from 'react';
import { CONFIG_LOGS, LOG_TABLE_TITLE } from '../../alertConfig.constants';
import { StyledSpace } from '../../styled';
import ConfigChangeLogs from '../ConfigChangelogs';

export default function ConfigDropdown () {
  const [displayLogsPopup, setDisplayLogsPopup] = useState(false);
  const kebabItems = [{
    key: CONFIG_LOGS,
    label: LOG_TABLE_TITLE,
    disabled: false,
  }];

  const onToggle = () => {
    setDisplayLogsPopup(state => !state);
  };

  const onApply = ({ key: kebabId }:any) => {
    switch (kebabId) {
      case CONFIG_LOGS:
        onToggle();
        break;
      default:
        break;
    }
  };

  const renderLogsPopup = () => (
    <ConfigChangeLogs isOpen={displayLogsPopup} toggleOpen={onToggle} />
  );

  return (
    <>
      <Dropdown
        menu={{ items: kebabItems, onClick: onApply }}
        trigger={['click']}
      >
        <StyledSpace>
          <MoreOutlined />
        </StyledSpace>
      </Dropdown>
      {displayLogsPopup && renderLogsPopup()}
    </>
  )
}
